import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from 'vue';
import appStoreModule from '@/store/modules/app';
import {searchCategories, searchVarieties, getSpecsById} from '@/api/miscellaneous';


export default /*#__PURE__*/_defineComponent({
  __name: 'VarietiesSearch',
  props: {
    show: {
        type: Boolean,
        default: false,
    },
},
  emits: ['confirm', 'update:show'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props



const text = ref('');
const getListData = ref({
    page: 1,
    size: 20,
    name: '',
});
const categories = ref<any[]>([]);
const history = ref<any[]>([]);

const loading = ref(false);
const finished = ref(false);

onMounted(() => {
    appStoreModule.init();
    history.value = appStoreModule.history;
});

let timer: any = null;
const searchVariety = (): void => {
    if (timer) clearTimeout(timer);
    loading.value = true;
    timer = setTimeout(() => {
        getListData.value.page = 1;
        if (getListData.value.name) {
            searchVarieties(getListData.value).then((res: any) => {
                loading.value = false;
                categories.value = res.items;
            });
        }
    }, 500);
};

const page = (): void => {
    if (loading.value) return;
    loading.value = true;
    getListData.value.page += 1;
    searchVarieties(getListData.value).then((res: any) => {
        categories.value = [...categories.value, ...res.items];
        loading.value = false;
        finished.value = res.count == 0 ? true : getListData.value.page * getListData.value.size > res.totalCount;
    });
};

const searchList = (data: any) => {
    getSpecsById({id: data.id || data.categoryId}).then((res: any) => {
        getListData.value.name = '';
        getListData.value.page = 1;
        categories.value = [];
        // isShowSearch.value = false;
        appStoreModule.setVariety({data, type: 'history'});
        history.value = appStoreModule.history;
        emit('confirm', res, data);
    });
};

const __returned__ = { props, emit, text, getListData, categories, history, loading, finished, timer, searchVariety, page, searchList, onMounted, ref, appStoreModule, searchCategories, searchVarieties, getSpecsById }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})